import { useEffect, useState } from "react";

export const convertToGrouped = (steps) => {
  const newGrouped = [];

  steps.forEach((item) => {
    if (!item.group?.id) {
      newGrouped.push(item);
      return;
    }

    const existingIndex = newGrouped.findIndex(
      (elem) => elem.id === item.group.id
    );

    if (existingIndex !== -1) {
      newGrouped[existingIndex].steps = [
        ...(newGrouped[existingIndex].steps || []),
        item,
      ];
      return;
    }

    newGrouped.push({
      ...item.group,
      id: item.group.id,
      image: item.image,
      order: item.order,
      properties: {
        actionType: "Group",
        description: item.group.description || "",
      },
      steps: [item],
    });
  });

  const withFixedOrder = newGrouped.map((item) => {
    if (!item.steps || item.steps.length === 0) {
      return item;
    }

    const sortedSteps = [...item.steps].sort(
      (a, b) => (a.order ?? 0) - (b.order ?? 0)
    );

    const firstStepOrder = sortedSteps[0]?.order ?? item.order ?? 0;

    return {
      ...item,
      order: firstStepOrder,
      steps: sortedSteps,
    };
  });

  withFixedOrder.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return withFixedOrder;
};

const useGroupedSteps = ({ steps }) => {
  const [grouped, setGrouped] = useState([]);
  const [checkedForGroup, setCheckedForGroup] = useState([]);

  useEffect(() => {
    if (!steps) return;
    setGrouped(convertToGrouped(steps));
  }, [steps]);

  return {
    grouped,
    setGrouped,
    checkedForGroup,
    setCheckedForGroup,
  };
};

export default useGroupedSteps;
